import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from '@store/errorLogicConfig/logData/actions';
import { logDataSortSelector, loadingSelector } from '@store/errorLogicConfig/logData/selectors';
import { Retry } from '@components/common';
import Summary from '../Common/Summary';
import { logColumns } from './utils';
import { ContentWrapper, DataTableWrapper } from '../styled';
import Table from '@components/common/Table';

//TODO: the sort key is shared between the tables, cleanup
import { setConfigSorting } from '@store/errorLogicConfig/base/actions';

function LogTable() {
  const dispatch = useDispatch();
  const { data, sort } = useSelector(logDataSortSelector);
  const { loading, showError } = useSelector(loadingSelector);

  const onColumnSort = ({ key, order }) => {
    dispatch(setConfigSorting({ key, order }));
  }

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  const retryAction = () => dispatch(fetchData());

  return (
    <ContentWrapper>
      <Summary />
      <DataTableWrapper>
        <Retry
          isLoading={loading}
          showError={showError}
          fetchData={retryAction}
        >
          <Table
            fixed
            data={data}
            columns={logColumns}
            onColumnSort={onColumnSort}
            sortBy={sort}
          />
        </Retry>
      </DataTableWrapper>
    </ContentWrapper>
  );
}

export default LogTable;
